module.exports = __webpack_public_path__ + "static/p-15-ad2f1fcad94b5456ad0abc5c5ac7fc61.jpg";